import React from "react";
import { FiClock } from "react-icons/fi";

const ClockBar = ({ glass, formattedTime, formattedDate, use24h, setUse24h }) => {
    return (
        <div className="absolute bottom-1 left-1/2 -translate-x-1/2 z-[10000]">
            <div className={`px-3 py-1.5 md:px-4 md:py-2 rounded-2xl ${glass} text-white shadow-2xl`}>
                <div className="flex items-center justify-center gap-3 md:gap-4">
                    <FiClock className="text-lg md:text-xl text-blue-300" />
                    <div className="text-center md:text-left">
                        <div className="text-base md:text-lg font-bold tabular-nums">
                            {formattedTime}
                        </div>
                        <div className="text-[10px] md:text-[11px] opacity-80">
                            {formattedDate}
                        </div>
                    </div>
                    <button
                        onClick={() => setUse24h((v) => !v)}
                        className="px-2 py-1 rounded-lg text-[11px] font-bold border border-white/40 bg-white/10 hover:bg-white/20 transition-all duration-200"
                        title="Toggle 12/24h format"
                    >
                        {use24h ? "24h" : "12h"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ClockBar;


